/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import { Badge,OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  MDBCol,
  MDBPageItem,
  MDBPageNav,
  MDBPagination,
  MDBRow,
} from "mdbreact";
import Moment from "react-moment";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import moment from 'moment';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import swal from "sweetalert";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import AppConfig from "../../../config/AppConfig";

const bgImage = toAbsoluteUrl("/media/bg/bg-10.jpg");
class PenugasanFaswil extends Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal1 = this.closeModal1.bind(this);
    this.modalDetail = this.modalDetail.bind(this);
    this.modalDetailPenetapanStandar = this.modalDetailPenetapanStandar.bind(this);
    this.modalDetailEvaluasiPelaksanaan = this.modalDetailEvaluasiPelaksanaan.bind(this);
    this.modalDetailPengendalian = this.modalDetailPengendalian.bind(this);
    this.modalDetailPeningkatan = this.modalDetailPeningkatan.bind(this);
    this.modalEdit = this.modalEdit.bind(this);
    this.modalSuccess = this.modalSuccess.bind(this);
  }
  state = {
    // MODAL ============================
    modalDetail: false,
    modalDetailPenetapanStandar: false,
    modalDetailEvaluasiPelaksanaan: false,
    modalDetailPengendalian: false,
    modalDetailPeningkatan: false,
    modalAddURole: false,
    modalEdit: false,
    modalResetPass: false,
    modalSuccess: false,
    // showDialogDeleteSPPenugasan: false,
    // ==================================
    loadingBtn: false,
    loadingBtnReset: false,
    loadingList: true,
    loadingSearch: false,
    loadingDetails: true,
    loadingDetailPenetapanStandar: true,
    loadingDetailEvaluasiPelaksanaan: true,
    loadingDetailPengendalian: true,
    loadingDetailPeningkatan: true,
    loadingEdit: true,
    loadingSP: false,
    displaySP: false,
    // ==================================
    dataPenugasan: [],
    listPTPenugasan: [],
    keyword: "",
    lingkup_koordinasi: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
    ref_lingkup: [],
    filter_bp: "",
    filter_role: "",
    start_date: '',
    start_date_value: '',
    end_date: '',
    end_date_value: '',
    detailPenugasan: [],
    detailAjuan: [],
    detailFaswil:{
      nm_pengguna: "",
      nm_lemb: "",
    },
    dataSP: [],
    id_sp: "",
    nama_sp: "",
    edit_id_pengguna: "",
    edit_id_lemb_asal: "",
    edit_nm_lemb_asal: "",
  };

  closeModal1() {
    this.setState({
      modalDetail: false,
      modalDetailPenetapanStandar: false,
      modalDetailEvaluasiPelaksanaan: false,
      modalDetailPengendalian: false,
      modalDetailPeningkatan: false,
      modalEdit: false,
      loadingBtn: false,
    });
  }
  componentDidMount() {
    console.log(this.state.start);
    this.setState({ loadingList: true });
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    if (sessiondata.i_idrole !== 2014 && sessiondata.i_idrole !== 10) {
      window.history.back();
    }
    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    if(this.state.start_date !== ""){
      formData.append("data[start_date]", moment(this.state.start_date).format('YYYY-MM-DD'));
    }
    if(this.state.end_date !== ""){
      formData.append("data[end_date]", moment(this.state.end_date).format('YYYY-MM-DD'));
    }
    formData.append(
      "data[lingkup_koordinasi]",
      sessiondata.i_idrole === 2014
        ? sessiondata.i_idunit
        : this.state.lingkup_koordinasi
    );
    formData.append("data[id_bp]", sessiondata.i_idbp);
    formData.append(
      "data[lingkup_koordinasi]",
      sessiondata.i_idrole === 2014
        ? sessiondata.i_idunit
        : this.state.lingkup_koordinasi
    );
    axios
      .post(
        AppConfig.ListPenugasanFaswil +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        this.setState(
          {
            loadingList: false,
            loadingSearch: false,
            dataPenugasan: res.data.result.data,
            totalData: res.data.result.total_rows,
            ref_lingkup: res.data.result.ref_lingkup,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            console.log(this.state.dataPenugasan);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Edit User ============================================================================
  modalDetail = (id) => {
    this.setState({ modalDetail: true, loadingDetails: true });
    axios
      .get(AppConfig.DetailPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          loadingDetails: false,
          detailPenugasan: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  modalDetailPenetapanStandar = (id) => {
    this.state.detailFaswil.nm_pengguna = "";
    this.state.detailFaswil.nm_lemb = "";
    this.setState({ modalDetailPenetapanStandar: true, loadingDetailPenetapanStandar: true });
    axios
      .get(AppConfig.ListPenetapanStandarPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          loadingDetailPenetapanStandar: false,
          detailAjuan: res.data.result.data,
          detailFaswil: res.data.result.faswil,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  modalDetailEvaluasiPelaksanaan = (id) => {
    this.state.detailFaswil.nm_pengguna = "";
    this.state.detailFaswil.nm_lemb = "";
    this.setState({ modalDetailEvaluasiPelaksanaan: true, loadingDetailEvaluasiPelaksanaan: true });
    axios
      .get(AppConfig.ListEvaluasiPelaksanaanPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          loadingDetailEvaluasiPelaksanaan: false,
          detailAjuan: res.data.result.data,
          detailFaswil: res.data.result.faswil,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  modalDetailPengendalian = (id) => {
    this.state.detailFaswil.nm_pengguna = "";
    this.state.detailFaswil.nm_lemb = "";
    this.setState({ modalDetailPengendalian: true, loadingDetailPengendalian: true });
    axios
      .get(AppConfig.ListPengendalianPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          loadingDetailPengendalian: false,
          detailAjuan: res.data.result.data,
          detailFaswil: res.data.result.faswil,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  modalDetailPeningkatan = (id) => {
    this.state.detailFaswil.nm_pengguna = "";
    this.state.detailFaswil.nm_lemb = "";
    this.setState({ modalDetailPeningkatan: true, loadingDetailPeningkatan: true });
    axios
      .get(AppConfig.ListPeningkatanPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          loadingDetailPeningkatan: false,
          detailAjuan: res.data.result.data,
          detailFaswil: res.data.result.faswil,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  modalEdit = (id_lemb_asal, nm_lemb_asal, id) => {
    this.setState({ modalEdit: true, loadingEdit: true });
    axios
      .get(AppConfig.EditPenugasanFaswil + id)
      .then((res) => {
        this.setState({
          listPTPenugasan: res.data.result.data,
          edit_id_pengguna: id,
          edit_id_lemb_asal: id_lemb_asal,
          edit_nm_lemb_asal: nm_lemb_asal,
          dataSP: [],
          loadingEdit: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onClickSavePenugasan = (e, id_pengguna, id_organisasi) => {
    e.preventDefault();
    var formData = new FormData();
    this.setState({ loadingSearch: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_pengguna]", id_pengguna);
    formData.append("data[id_sp]", this.state.id_sp);
    formData.append("data[id_organisasi]", id_organisasi);
    axios
      .post(AppConfig.SavePTPenugasanFaswil + session, formData)
      .then((res) => {
        this.setState({
          loadingSearch: false,
          id_sp: "",
          nama_sp: "",
        });
        if (res.data.status === "sukses") {
          swal({
            title: "Sukses!",
            text: "Data berhasil ditambahkan!",
            icon: "success",
            button: "OK!",
          });
          this.setState({
            id_sp: "",
            nama_sp: "",
          });
          this.closeModal1();
          this.componentDidMount();
        } else {
          swal({
            title: "Gagal!",
            text: res.data.message,
            icon: "warning",
            button: "OK!",
          });
        }
      })
      .catch((err) => {
        this.setState({
          loadingSearch: false,
        });
        swal({
          title: "Gagal!",
          text: "Gagal menambah data!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };

  showDialogDeleteSPPenugasan(id_penugasan_faswil) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(
            AppConfig.DeletePenugasanFaswil + id_penugasan_faswil + session
          )
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.closeModal1();
            this.componentDidMount();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  showDialogDeletePenugasan(id_pengguna) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteAllPenugasanFaswil + id_pengguna + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.closeModal1();
            this.componentDidMount();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  modalSuccess = () => {
    this.setState({ modalSuccess: true });
  };
  closeModalSuccess = () => {
    this.setState({ modalSuccess: false });
  };

  // Searh
  onClickSearch = (e) => {
    console.log("test masuk");
    console.log(this.state);
    this.setState(
      {
        loadingSearch: true,
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onClickResetKeyword = (e) => {
    this.setState(
      {
        keyword: "",
        lingkup_koordinasi: "",
        start_date:"",
        end_date:"",
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  selectedFilterOrganisasi = (val) => {
    this.setState({ val });
    this.setState({
      lingkup_koordinasi: val.value,
    });
  };
  // Pagination
  getPaginationGroup = () => {
    let start =
      Math.floor((this.state.currentPage - 1) / this.state.pageLimit) *
      this.state.pageLimit;
    return new Array(this.state.pageLimit)
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  pagination(e, numb) {
    let dataStart = numb * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: numb,
      },
      () => {
        this.componentDidMount();
      }
    );
  }
  firstPagination = () => {
    let first = this.state.currentPage / this.state.currentPage;
    let dataStart = first * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: first,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  prevPagination = () => {
    let prev = this.state.currentPage - 1;
    let dataStart = prev * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: prev,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  nextPagination = () => {
    let next = this.state.currentPage + 1;
    let dataStart = next * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: next,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onInputChangeName = (e, type) => {
    console.log(type);
    console.log(e.target.value);
    this.setState({
      [type]: e.target.value,
    });

    console.log(this.state);
  };
  onChangeStart = (startDate) => {
    this.setState({
      start_date_value : moment(startDate).format('YYYY-MM-DD'),
      start_date : startDate,
    });
    console.log(this.state);
  };
  onChangeEnd = (endDate) => {
    this.setState({
      end_date_value : moment(endDate).format('YYYY-MM-DD'),
      end_date : endDate,
    });
    console.log(this.state);
  };
  onInputChangeKordinasi = (e, type) => {
    console.log(type);
    console.log(e.target.value);
    this.setState({
      lingkup_koordinasi: e.target.value,
    });

    console.log(this.state);
  };
  lastPagination = () => {
    let last = this.state.totalPaginationNumber;
    let dataStart = last * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: last,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  onChangeSP = (e, id_pembina) => {
    this.setState({
      id_sp: "",
      nama_sp: e.target.value,
    });
    if (e.target.value.length > 2) {
      this.setState({
        displaySP: false,
        loadingSP: true,
      });

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }

      var formData = new FormData();
      formData.append("data[id_pembina]", id_pembina);
      formData.append("data[keyword]", e.target.value);
      formData.append("data[id_bp]", sessiondata.i_idbp);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios
        .post(AppConfig.GetPTPenugasanFaswil + session, formData)
        .then((res) => {
          if (res.status === 200) {
          }
          this.setState({
            dataSP: res.data.result.data,
            displaySP: true,
            loadingSP: false,
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    } else {
      this.setState({
        displaySP: false,
      });
    }
  };
  onClickSelectSP = (id_sp, nama_sp) => {
    this.setState({
      id_sp: id_sp,
      nama_sp: nama_sp,
      displaySP: false,
    });
  };

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    const { ref_lingkup, lingkup_koordinasi } = this.state;
    var i = 0;
    let result_ref = [];
    for (var key in ref_lingkup) {
      result_ref[i] = {
        name: key,
        result: ref_lingkup[key],
      };
      i++;
    }

    let no = this.state.showFrom - 1;

    let ii = 0;
    let list_penugasan = [];
    if (this.state.dataPenugasan !== undefined) {
      for (var key in this.state.dataPenugasan) {
        list_penugasan[ii] = {
          result: this.state.dataPenugasan[key],
        };
        ii++;
      }
    }
    let loadingSearch = <></>;
    if (this.state.loadingSearch === true) {
      loadingSearch = (
        <i
          className="spinner spinner-white"
          style={{ marginRight: "20px" }}
        ></i>
      );
    }
    let loadSP = <></>;
    if (this.state.loadingSP === true) {
      loadSP = (
        <i
          className="ml-3 spinner spinner-black"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "45px",
            bottom: "20px",
          }}
        ></i>
      );
    }

    let pagination = <></>;
    if (this.state.loadingList === false) {
      pagination = (
        <>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <MDBRow>
              <MDBCol>
                <MDBPagination circle>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.firstPagination(e)}
                    >
                      <span>First</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => this.prevPagination(e)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  {this.getPaginationGroup()
                    .filter(
                      (index) => index <= this.state.totalPaginationNumber
                    )
                    .map((item, index) => (
                      <MDBPageItem
                        active={this.state.currentPage === item ? true : false}
                        key={index}
                      >
                        <MDBPageNav
                          className="page-link"
                          onClick={(e) => this.pagination(e, item)}
                        >
                          {item}
                        </MDBPageNav>
                      </MDBPageItem>
                    ))}
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.nextPagination(e)}
                    >
                      &raquo;
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.lastPagination(e)}
                    >
                      Last
                    </MDBPageNav>
                  </MDBPageItem>
                </MDBPagination>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      );
    }

    let listSPPenugasan = <></>;
    if (this.state.displaySP === true) {
      if (this.state.dataSP) {
        let dataSp = [];
        this.state.dataSP.map((v, i) => {
          dataSp.push(
            <div
              onClick={(e) => this.onClickSelectSP(v.id_sp, v.nm_lemb)}
              style={{
                background: "#fff",
                padding: "10px",
                color: "#2c2c2c",
                borderBottom: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              {v.nm_lemb}
            </div>
          );
        });
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              width: "100%",
            }}
          >
            {dataSp}
          </div>
        );
      } else {
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              background: "#fff",
              padding: "10px",
              color: "#ccc",
              borderBottom: "1px solid #ccc",
              cursor: "pointer",
              fontStyle: "italic",
            }}
          >
            Data perguruan tinggi tidak ditemukan.
          </div>
        );
      }
    }

    return (
      <>
        <div
          className="row row-paddingless"
          style={{
            backgroundImage: `url(${bgImage})`,
            padding: "2%",
            borderRadius: "5px",
            marginBottom: "20px",
          }}
        >
          <div className="col-md-12 text-white" style={{ textAlign: "left" }}>
            <h2 className="font-weight">Penugasan Fasilitator Wilayah</h2>
            <hr />
          </div>
          <div className="col-md-12 text-white" style={{ textAlign: "" }}>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Kata Kunci
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="text"
                    value={this.state.keyword}
                    onChange={(e) => this.onInputChangeName(e, "keyword")}
                    className={`form-control form-control-lg form-control-solid `}
                    placeholder="Masukan keyword : Username / Nama Pengguna"
                    name="keyword"
                  />
                </div>
              </div>
            </div>
            {userdata.i_idrole === 2014 ? (
              ""
            ) : (
              <>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 text-white">
                    Lingkup Koordinasi
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      value={lingkup_koordinasi}
                      onChange={(e) =>
                        this.onInputChangeKordinasi(e, "lingkup_koordinasi")
                      }
                      className="form-control form-control-lg form-control-solid"
                      name="language"
                    >
                      <option value="">Semua Unit</option>
                      {result_ref.map((list, i) => (
                        <option value={list.name}>{list.result}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Tanggal Mulai Verifikasi
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <DatePicker dateFormat="yyyy/MM/dd" selected={this.state.start_date} className={`form-control form-control-lg form-control-solid `} onChange={(e) => this.onChangeStart(e)} />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Tanggal Akhir Verifikasi
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                <DatePicker dateFormat="yyyy/MM/dd"  selected={this.state.end_date} className={`form-control form-control-lg form-control-solid `} onChange={(e) => this.onChangeEnd(e)} />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label"></label>
              <div
                className="col-lg-9 col-xl-6"
              >
                <Button variant="primary" onClick={this.onClickSearch}>
                  Filter Data &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-search"></span>
                </Button>
                <Button
                  variant="default"
                  style={{ marginLeft: "10px" }}
                  onClick={this.onClickResetKeyword}
                >
                  Reset &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-times"></span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="offset-md-8"></div>
                <div className="col-md-4 text-right">
                  <Link to="/penugasan-faswil-add">
                    <Button
                      variant="primary"
                      style={{
                        padding: "12px",
                        width: "50%",
                      }}
                    >
                      <i
                        className="flaticon-add"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                      &nbsp; Tambah Penugasan
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    width: "5%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama User
                </th>
                <th
                  style={{
                    width: "10%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Lingkup Koordinasi
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Jumlah Penugasan
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-bottom`}>
                        <div style={{ textAlign: "left" }}>
                          Jumlah PT yang ditugaskan.
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ fontSize: "15px" }}
                      className="text-white fa fa-info-circle ml-2"
                    ></span>
                  </OverlayTrigger>
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Penetapan Standar
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-bottom`}>
                        <div style={{ textAlign: "left" }}>
                          Jumlah ajuan yang sudah diverifikasi di Penetapan Standar.
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ fontSize: "15px" }}
                      className="text-white fa fa-info-circle ml-2"
                    ></span>
                  </OverlayTrigger>
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Evaluasi Pelaksanaan
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-bottom`}>
                        <div style={{ textAlign: "left" }}>
                          Jumlah ajuan yang sudah diverifikasi di Evaluasi Pelaksanaan.
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ fontSize: "15px" }}
                      className="text-white fa fa-info-circle ml-2"
                    ></span>
                  </OverlayTrigger>
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Pengendalian Hasil Evaluasi
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-bottom`}>
                        <div style={{ textAlign: "left" }}>
                          Jumlah ajuan yang sudah diverifikasi di Pengendalian Hasil Evaluasi.
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ fontSize: "15px" }}
                      className="text-white fa fa-info-circle ml-2"
                    ></span>
                  </OverlayTrigger>
                </th>
                <th
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Peningkatan Standar
                  <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-bottom`}>
                        <div style={{ textAlign: "left" }}>
                          Jumlah ajuan yang sudah diverifikasi di Peningkatan Standar.
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ fontSize: "15px" }}
                      className="text-white fa fa-info-circle ml-2"
                    ></span>
                  </OverlayTrigger>
                </th>
                <th
                  className="text-center"
                  style={{
                    width: "15%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="9">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_penugasan.length > 0 ? (
                list_penugasan.map((list) => (
                  <tr>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {(no = no + 1)}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_pengguna}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_lemb}
                    </td>
                    <td
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      {list.result.jum_penugasan}
                      {
                        (list.result.jum_penugasan > 0) ? 
                          <ButtonToolbar
                          onClick={() =>
                            this.modalDetail(list.result.id_pengguna)
                          }
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            marginRight: "5px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-eye"
                              style={{ color: "#FFFFFF", fontSize: "16px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                        :""
                      }
                     
                    </td>
                    <td
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      {list.result.penetapan_standar}
                      {
                        (list.result.penetapan_standar > 0) ?
                          <ButtonToolbar
                          onClick={() =>
                            this.modalDetailPenetapanStandar(list.result.id_pengguna)
                          }
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            marginRight: "5px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-eye"
                              style={{ color: "#FFFFFF", fontSize: "16px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                        :""
                      }
                    </td>
                    <td
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      {list.result.evaluasi_pelaksanaan}
                      {
                        (list.result.evaluasi_pelaksanaan > 0) ?
                          <ButtonToolbar
                          onClick={() =>
                            this.modalDetailEvaluasiPelaksanaan(list.result.id_pengguna)
                          }
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            marginRight: "5px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-eye"
                              style={{ color: "#FFFFFF", fontSize: "16px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                        :""
                      }
                    </td>
                    <td
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      {list.result.pengendalian_hasil_evaluasi}
                      {
                        (list.result.pengendalian_hasil_evaluasi > 0) ?
                          <ButtonToolbar
                          onClick={() =>
                            this.modalDetailPengendalian(list.result.id_pengguna)
                          }
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            marginRight: "5px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-eye"
                              style={{ color: "#FFFFFF", fontSize: "16px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                        :""
                      }
                    </td>
                    <td
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      {list.result.peningkatan_standar}
                      {
                        (list.result.peningkatan_standar > 0) ?
                          <ButtonToolbar
                          onClick={() =>
                            this.modalDetailPeningkatan(list.result.id_pengguna)
                          }
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            marginRight: "5px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-eye"
                              style={{ color: "#FFFFFF", fontSize: "16px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                        :""
                      }
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      <ButtonToolbar
                        onClick={() => this.modalEdit(list.result.id_lembaga_asal, list.result.nm_lemb, list.result.id_pengguna)}
                        className="btn btn-icon btn-info btn-sm"
                        style={{
                          minWidth: "50px",
                          marginRight: "5px",
                          borderRadius: "12px",
                        }}
                      >
                        <div>
                          <i
                            className="flaticon-edit"
                            style={{ color: "#FFFFFF", fontSize: "14px" }}
                          ></i>
                        </div>
                      </ButtonToolbar>
                      <Button
                        onClick={() =>
                          this.showDialogDeletePenugasan(
                            list.result.id_pengguna
                          )
                        }
                        className="btn btn-icon btn-danger btn-sm"
                        style={{ minWidth: "50px", borderRadius: "12px" }}
                      >
                        <i
                          className="flaticon-delete"
                          style={{ color: "#FFFFFF", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </>
              )}
            </tbody>
          </Table>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-4 text-left">
              {" "}
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Page <strong>{this.state.currentPage}</strong> of{" "}
                <strong>{this.state.totalPaginationNumber}</strong>
              </label>
            </div>
            <div className="col-md-4">{pagination}</div>
            <div className="col-md-4 text-right">
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Showing <strong>{this.state.showFrom}</strong> to{" "}
                <strong>
                  {this.state.showFrom + this.state.dataPenugasan.length - 1}
                </strong>{" "}
                of <strong>{this.state.totalData}</strong> Data
              </label>
            </div>
          </div>
          {/*========================================== End Table ========================================== */}
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="xl"
          show={this.state.modalDetailPenetapanStandar}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Detail Penugasan Ajuan Penetapan Standar{" "}
              {this.state.detailFaswil.nm_pengguna !== ""
                ? " - " +
                  this.state.detailFaswil.nm_pengguna +
                  " (" +
                  this.state.detailFaswil.nm_lemb +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetailPenetapanStandar === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
              {this.state.detailAjuan.length > 0 ? (
                  this.state.detailAjuan.map((list, key) => (
                    <>
                      <h2>{list.nm_lemb}</h2>
                      <Table responsive style={{ overflow: "auto", marginTop:"10px" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              No
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Bidang Pengaturan Standar
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tautan
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Dokumen
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Dibuat
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.data_ajuan.map.length > 0 ? (
                            list.data_ajuan.map((list2, key2) => (
                              <tr>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  {key2 + 1}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                >
                                  {
                                    (list2.keterangan === "null") ?
                                    (list2.id_jenis_aturan === 1) ?
                                    "Pengaturan pengelolaan SPMI Institusi":
                                    (list2.id_jenis_aturan === 2) ?
                                    "Pengaturan organisasi pengelola SPMI Institusi":
                                    (list2.id_jenis_aturan === 3) ?
                                    "Pengaturan terkait pelaksanaan standar dalam SPMI Institusi":
                                    (list2.id_jenis_aturan === 4) ?
                                    "Pengaturan terkait evaluasi pelaksanaan standar":
                                    (list2.id_jenis_aturan === 5) ?
                                    "Pengaturan terkait pengendalian pelaksanaan standar":
                                    (list2.id_jenis_aturan === 6) ?
                                    "Pengaturan terkait peningkatan standar dalam SPMI Institusi":
                                    (list2.id_jenis_aturan === 7) ?
                                    "Standar di aspek pendidikan":
                                    (list2.id_jenis_aturan === 8) ?
                                    "Standar di aspek penelitian":
                                    (list2.id_jenis_aturan === 9) ?
                                    "Standar di aspek pengabdian pada masyarakat":
                                    (list2.id_jenis_aturan === 10) ?
                                    "Aspek pengelolaan organisasi":
                                    (list2.id_jenis_aturan === 11) ?
                                    "Aspek kemahasiswaan":
                                    (list2.id_jenis_aturan === 12) ?
                                    "Aspek sumber daya manusia":
                                    (list2.id_jenis_aturan === 13) ?
                                    "Aspek sarana prasarana":
                                    (list2.id_jenis_aturan === 14) ?
                                    "Aspek kerjasama":
                                    (list2.id_jenis_aturan === 15) ?
                                    "Aspek keuangan":
                                    (list2.id_jenis_aturan === 16) ?
                                    "Aspek kesejahteraan":
                                    ""
                                    : list2.keterangan
                                  }
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                <Button
                                  href={list2.tautan}
                                  target="_blank"
                                  className="btn btn-icon btn-light btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    borderRadius: "12px",
                                    background: "#A9C6DE",
                                  }}
                                >
                                  <i
                                    className="flaticon-attachment"
                                    style={{ color: "#3F4254", fontSize: "14px" }}
                                  ></i>
                                </Button>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.statusajuan === 3 ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Terverifikasi
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Terverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.dokumen_valid === "1" ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Sudah Valid
                                    </Badge>
                                  ) : list2.dokumen_valid === "0" ? (
                                    <Badge
                                      pill
                                      variant="warning"
                                      style={{
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Valid
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                                    >
                                      Dokumen belum diverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.created_at ? list2.created_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.updated_at ? list2.updated_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Link
                                    to={
                                      "/ajuan-pengaturan/detail/" +
                                      list2.idajuanpengaturan
                                    }
                                    target="_blank"
                                  >
                                    <Button
                                      className="btn btn-icon btn-primary btn-sm"
                                      style={{ minWidth: "50px", borderRadius: "12px" }}
                                    >
                                      <i
                                        className="flaticon-eye"
                                        style={{ color: "#ffffff", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                <em>Data does not exist</em>
                              </td>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          show={this.state.modalDetailEvaluasiPelaksanaan}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Detail Penugasan Ajuan Evaluasi Pelaksanaan{" "}
              {this.state.detailFaswil.nm_pengguna !== ""
                ? " - " +
                  this.state.detailFaswil.nm_pengguna +
                  " (" +
                  this.state.detailFaswil.nm_lemb +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetailEvaluasiPelaksanaan === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
              {this.state.detailAjuan.length > 0 ? (
                  this.state.detailAjuan.map((list, key) => (
                    <>
                      <h2>{list.nm_lemb}</h2>
                      <Table responsive style={{ overflow: "auto", marginTop:"10px" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              No
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Nama Bentuk Evaluasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tautan
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Dokumen
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Dibuat
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.data_ajuan.map.length > 0 ? (
                            list.data_ajuan.map((list2, key2) => (
                              <tr>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  {key2 + 1}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                >
                                  {
                                    (list2.keterangan === "null") ?
                                    (list2.id_jenis_evaluasi === 1) ?
                                    "Fungsi pengawasan yang terintegrasi sesuai fungsi organisasi":
                                    (list2.id_jenis_evaluasi === 2) ?
                                    "Wawancara":
                                    (list2.id_jenis_evaluasi === 3) ?
                                    "Evaluasi Diri":
                                    (list2.id_jenis_evaluasi === 4) ?
                                    "Survey":
                                    (list2.id_jenis_evaluasi === 5) ?
                                    "Praktik Baik Atau Mekanisme":
                                    (list2.id_jenis_evaluasi === 6) ?
                                    "Temuan":
                                    (list2.id_jenis_evaluasi === 7) ?
                                    "Rekomendasi Peningkatan Mutu":
                                    ""
                                    : list2.keterangan
                                  }
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                <Button
                                  href={list2.tautan}
                                  target="_blank"
                                  className="btn btn-icon btn-light btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    borderRadius: "12px",
                                    background: "#A9C6DE",
                                  }}
                                >
                                  <i
                                    className="flaticon-attachment"
                                    style={{ color: "#3F4254", fontSize: "14px" }}
                                  ></i>
                                </Button>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.statusajuan === 3 ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Terverifikasi
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Terverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.dokumen_valid === "1" ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Sudah Valid
                                    </Badge>
                                  ) : list2.dokumen_valid === "0" ? (
                                    <Badge
                                      pill
                                      variant="warning"
                                      style={{
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Valid
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                                    >
                                      Dokumen belum diverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.created_at ? list2.created_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.updated_at ? list2.updated_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Link
                                    to={
                                      "/ajuan-evaluasi/detail/" +
                                      list2.idajuanevaluasi
                                    }
                                    target="_blank"
                                  >
                                    <Button
                                      className="btn btn-icon btn-primary btn-sm"
                                      style={{ minWidth: "50px", borderRadius: "12px" }}
                                    >
                                      <i
                                        className="flaticon-eye"
                                        style={{ color: "#ffffff", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                <em>Data does not exist</em>
                              </td>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          show={this.state.modalDetailPengendalian}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Detail Penugasan Ajuan Pengendalian Hasil Evaluasi{" "}
              {this.state.detailFaswil.nm_pengguna !== ""
                ? " - " +
                  this.state.detailFaswil.nm_pengguna +
                  " (" +
                  this.state.detailFaswil.nm_lemb +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetailPengendalian === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
              {this.state.detailAjuan.length > 0 ? (
                  this.state.detailAjuan.map((list, key) => (
                    <>
                      <h2>{list.nm_lemb}</h2>
                      <Table responsive style={{ overflow: "auto", marginTop:"10px" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              No
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Nama Bidang Pengaturan Standar
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tautan RTL
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tautan RTM
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Dokumen
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Dibuat
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.data_ajuan.map.length > 0 ? (
                            list.data_ajuan.map((list2, key2) => (
                              <tr>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  {key2 + 1}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                >
                                  {
                                    (list2.nama_jenis !== "null") ?
                                    list2.nama_jenis
                                    : ""
                                  }
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  {
                                    (list2.rtl !== "null") ? 
                                    <Button
                                      href={list2.rtl}
                                      target="_blank"
                                      className="btn btn-icon btn-light btn-sm"
                                      style={{
                                        minWidth: "50px",
                                        borderRadius: "12px",
                                        background: "#A9C6DE",
                                      }}
                                    >
                                      <i
                                        className="flaticon-attachment"
                                        style={{ color: "#3F4254", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                    : "Link dokumen kosong"
                                  }
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  {
                                    (list2.rtm !== "null") ? 
                                    <Button
                                      href={list2.rtm}
                                      target="_blank"
                                      className="btn btn-icon btn-light btn-sm"
                                      style={{
                                        minWidth: "50px",
                                        borderRadius: "12px",
                                        background: "#A9C6DE",
                                      }}
                                    >
                                      <i
                                        className="flaticon-attachment"
                                        style={{ color: "#3F4254", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                    :"Link dokumen kosong"
                                  }
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.statusajuan === 3 ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Terverifikasi
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Terverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.dokumen_valid === "1" ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Sudah Valid
                                    </Badge>
                                  ) : list2.dokumen_valid === "0" ? (
                                    <Badge
                                      pill
                                      variant="warning"
                                      style={{
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Valid
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                                    >
                                      Dokumen belum diverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.created_at ? list2.created_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.updated_at ? list2.updated_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Link
                                    to={
                                      "/ajuan-pengendalian/detail/" +
                                      list2.idpengendalian
                                    }
                                    target="_blank"
                                  >
                                    <Button
                                      className="btn btn-icon btn-primary btn-sm"
                                      style={{ minWidth: "50px", borderRadius: "12px" }}
                                    >
                                      <i
                                        className="flaticon-eye"
                                        style={{ color: "#ffffff", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                <em>Data does not exist</em>
                              </td>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          show={this.state.modalDetailPeningkatan}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Detail Penugasan Ajuan Peningkatan Standar{" "}
              {this.state.detailFaswil.nm_pengguna !== ""
                ? " - " +
                  this.state.detailFaswil.nm_pengguna +
                  " (" +
                  this.state.detailFaswil.nm_lemb +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetailPeningkatan === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
              {this.state.detailAjuan.length > 0 ? (
                  this.state.detailAjuan.map((list, key) => (
                    <>
                      <h2>{list.nm_lemb}</h2>
                      <Table responsive style={{ overflow: "auto", marginTop:"10px" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "10%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              No
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Nama Pengaturan
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tautan
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Status Dokumen
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Dibuat
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Tanggal Verifikasi
                            </th>
                            <th
                              style={{
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.data_ajuan.map.length > 0 ? (
                            list.data_ajuan.map((list2, key2) => (
                              <tr>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  {key2 + 1}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                >
                                  {
                                    (list2.keterangan === "null") ?
                                    (list2.id_jenis_aturan === 1) ?
                                    "Pengaturan pengelolaan SPMI Institusi":
                                    (list2.id_jenis_aturan === 2) ?
                                    "Pengaturan organisasi pengelola SPMI Institusi":
                                    (list2.id_jenis_aturan === 3) ?
                                    "Pengaturan terkait pelaksanaan standar dalam SPMI Institusi":
                                    (list2.id_jenis_aturan === 4) ?
                                    "Pengaturan terkait evaluasi pelaksanaan standar":
                                    (list2.id_jenis_aturan === 5) ?
                                    "Pengaturan terkait pengendalian pelaksanaan standar":
                                    (list2.id_jenis_aturan === 6) ?
                                    "Pengaturan terkait peningkatan standar dalam SPMI Institusi":
                                    (list2.id_jenis_aturan === 7) ?
                                    "Rekomendasi Peningkatan Mutu":
                                    ""
                                    : list2.keterangan
                                  }
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                <Button
                                  href={list2.tautan}
                                  target="_blank"
                                  className="btn btn-icon btn-light btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    borderRadius: "12px",
                                    background: "#A9C6DE",
                                  }}
                                >
                                  <i
                                    className="flaticon-attachment"
                                    style={{ color: "#3F4254", fontSize: "14px" }}
                                  ></i>
                                </Button>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.statusajuan === 3 ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Terverifikasi
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Terverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {list2.dokumen_valid === "1" ? (
                                    <Badge
                                      pill
                                      variant="success"
                                      style={{
                                        backgroundColor: "#BEF2FF",
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <Badge variant="light">
                                        {" "}
                                        <span style={{ color: "#37bf30" }}>✔</span>
                                      </Badge>
                                      &nbsp;&nbsp;&nbsp; Sudah Valid
                                    </Badge>
                                  ) : list2.dokumen_valid === "0" ? (
                                    <Badge
                                      pill
                                      variant="warning"
                                      style={{
                                        color: "#334443",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Belum Valid
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      variant="secondary"
                                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                                    >
                                      Dokumen belum diverifikasi
                                    </Badge>
                                  )}
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.created_at ? list2.created_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{ verticalAlign: "middle" }}
                                  className="text-center"
                                >
                                  <Moment
                                    date={list2.updated_at ? list2.updated_at : "loading .."}
                                    format="DD/MM/YYYY"
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Link
                                    to={
                                      "/ajuan-peningkatan/detail/" +
                                      list2.idajuanpeningkatan
                                    }
                                    target="_blank"
                                  >
                                    <Button
                                      className="btn btn-icon btn-primary btn-sm"
                                      style={{ minWidth: "50px", borderRadius: "12px" }}
                                    >
                                      <i
                                        className="flaticon-eye"
                                        style={{ color: "#ffffff", fontSize: "14px" }}
                                      ></i>
                                    </Button>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                <em>Data does not exist</em>
                              </td>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Detail Penugasan{" "}
              {this.state.loadingDetails === false
                ? " - " +
                  this.state.detailPenugasan[0].nm_pengguna +
                  " (" +
                  this.state.detailPenugasan[0].nm_lemb +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Table responsive style={{ overflow: "auto" }}>
                  <thead
                    className="text-white"
                    style={{ backgroundColor: "#3047ad" }}
                  >
                    <tr>
                      <th
                        style={{
                          width: "10%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        No
                      </th>
                      <th
                        style={{
                          width: "90%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        Nama Perguruan Tinggi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.detailPenugasan.length > 0 ? (
                      this.state.detailPenugasan.map((list, key) => (
                        <tr>
                          <td
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            {key + 1}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.nm_sp}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          <em>Data does not exist</em>
                        </td>
                      </>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          show={this.state.modalEdit}
          onHide={this.closeModal1}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Edit Penugasan{" "}
              {this.state.loadingEdit === false
                ? " - " +
                  this.state.listPTPenugasan[0].nm_pengguna +
                  " (" +
                  this.state.edit_nm_lemb_asal +
                  ")"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingEdit === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row mb-10">
                  <div className="col-md-9">
                    <span>Perguruan Tinggi </span>
                    <i
                      className="flaticon-search text-dark"
                      style={{
                        position: "absolute",
                        zIndex: 2,
                        left: "25px",
                        bottom: "10px",
                      }}
                    ></i>
                    {loadSP}
                    <input
                      type="text"
                      style={{ marginTop: "1.8%", paddingLeft: "40px" }}
                      className={`form-control form-control-lg form-control-solid `}
                      placeholder="Masukan keyword : Nama perguruan tinggi.."
                      onChange={(e) =>
                        this.onChangeSP(
                          e,
                          this.state.edit_id_lemb_asal
                        )
                      }
                      autoComplete="off"
                      name="nama_sp"
                      value={this.state.nama_sp}
                    />
                    {listSPPenugasan}
                  </div>
                  <div className="col-md-3 text-center">
                    <Button
                      onClick={(e) =>
                        this.onClickSavePenugasan(
                          e,
                          this.state.listPTPenugasan[0].id_pengguna,
                          this.state.listPTPenugasan[0].id_organisasi
                        )
                      }
                      variant="primary"
                      style={{
                        marginTop: "25px",
                        padding: "12px",
                        width: "100%",
                      }}
                      disabled={
                        this.state.loadingSearch === true ||
                        this.state.id_sp === ""
                      }
                    >
                      {loadingSearch} Tambah
                    </Button>
                  </div>
                </div>
                <Table responsive style={{ overflow: "auto" }}>
                  <thead
                    className="text-white"
                    style={{ backgroundColor: "#3047ad" }}
                  >
                    <tr>
                      <th
                        style={{
                          width: "10%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        No
                      </th>
                      <th
                        style={{
                          width: "80%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        Nama Perguruan Tinggi
                      </th>
                      <th
                        style={{
                          width: "10%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        Aksi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.listPTPenugasan.length > 0 ? (
                      this.state.listPTPenugasan.map((list, key) => (
                        <tr>
                          <td
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            {key + 1}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.nm_sp}
                          </td>
                          <td className="text-center pr-0">
                            <Button
                              onClick={() =>
                                this.showDialogDeleteSPPenugasan(
                                  list.id_penugasan_faswil
                                )
                              }
                              className="btn btn-icon btn-danger btn-sm"
                              style={{ minWidth: "50px", borderRadius: "12px" }}
                            >
                              <i
                                className="flaticon-delete"
                                style={{ color: "#FFFFFF", fontSize: "14px" }}
                              ></i>
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          <em>Data does not exist</em>
                        </td>
                      </>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal1}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default PenugasanFaswil;
